import { useQuery } from '@tanstack/react-query';
import type { SocialLinkDTO } from '@meshsmith/shared';
import { api } from '../lib/api';

/** The footer's social links, as set by staff. Changes rarely, so it is cached for a while. */
export function useSocialLinks() {
  const { data } = useQuery({
    queryKey: ['social-links'],
    queryFn: () => api.get<{ links: SocialLinkDTO[] }>('/content/social'),
    staleTime: 10 * 60 * 1000,
  });
  return data?.links ?? [];
}
